var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilledInsta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_2594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9004 15C26.0802 15.1302 26.9999 16.13 27 17.3398V24.6602C26.9999 25.95 25.95 26.9999 24.6602 27H17.3398C16.05 26.9999 15.0001 25.95 15 24.6602V17.3398C15.0001 16.05 16.05 15.0001 17.3398 15H24.9004ZM21 18C20.2 18 19.4499 18.3099 18.8799 18.8799C18.3099 19.4399 18 20.2 18 21C18 21.8 18.3099 22.5501 18.8799 23.1201C19.4399 23.6901 20.2 24 21 24C21.8 24 22.5501 23.6901 23.1201 23.1201C23.6901 22.5601 24 21.8 24 21C24 20.2 23.6901 19.4499 23.1201 18.8799C22.5601 18.3099 21.8 18 21 18ZM25 16C24.45 16 24 16.45 24 17C24 17.55 24.45 18 25 18C25.55 18 26 17.55 26 17C26 16.45 25.55 16 25 16Z",
    fill: "#5F6774"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_2594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(15 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledInsta);
export default __webpack_public_path__ + "static/media/filledInsta.edf4ebbf6275f1bd6234449c58db268b.svg";
export { ForwardRef as ReactComponent };